import { defineMessages } from 'react-intl';

export default defineMessages({
  judgement: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgement',
  },
  deleteJudgement: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.delete_judgement',
  },
  uploadedDocument: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.uploaded_document',
  },
  expertiseTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.expertise_title',
  },
  expertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.expertise',
  },
  victims: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.victims',
  },
  vehicules: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.vehicules',
  },
  editJudgement: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.edit',
  },
  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  successDialogSecondaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.secondary_button_title',
  },
  successDialogTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.title',
  },
  arret: {
    id: 'legal_proceedings.expert_report_appeal.arret',
  },
  assignedLawyerTitle: {
    id: 'claim_with_not_indexed_PV.is_lawyer_assigned',
  },
  hearingDateTitle: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.title',
  },
  addNewAddDocument: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.add_new_add',
  },
  judgementAddIncomeCertificateButton: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.add',
  },
  successJudgementAdd: {
    id: 'success_dialog.fee_note',
  },
  doNotGenerateFeeNote: {
    id: 'success_dialog.do_not_generate_fee_note',
  },
  cancelMessage: {
    id: 'saham_dialog.cancel',
  },
  successToastTitle: {
    id: 'judgement_add_document.success',
  },
  supportDocument: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.support_document',
  },
  rejectedTitle: {
    id: 'legal_proceeding_page_info_rejected_title',
  },
  lawyerFirmReferenceUpdateMessage: {
    id: 'legal_proceeding_page.check_firm_reference_info',
  },
  lawyerFirmReferenceDialogLabel: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_label',
  },
  saveButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.saveButton',
  },
  editButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.updateButton',
  },
  creatorTitle: {
    id: 'legal_proceeding_page.update_firm_reference_lawyer_name',
  },
  creatorTitleMultiple: {
    id: 'legal_proceeding_page.judgement_add_multiple_created_by',
  },
  validate: { id: 'legal_proceedings.expert_report.validate' },
  lawyerFirmReferenceEditMessage: {
    id: 'legal_proceeding_page.check_update_firm_reference_info',
  },
  update: { id: 'legal_proceedings.expert_report.update' },
  courtManagerJudgementUpdate: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.update',
  },
  responsibilityShareWarning: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.responsibility_share_warning',
  },
  userNotValidWarning: {
    id: 'restricted_user_warning.title',
  },
  duplicateJaddWarning: {
    id: 'duplicate_add_warning.title',
  },
  incomeCertificateTitle: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.title',
  },
  income: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.income',
  },
  documentCertificate: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.document',
  },
  editIncomeCertificate: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.edit',
  },
  addIncomeCertificate: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.add',
  },
  save: {
    id: 'court_manager_legal_proceedings_page.drawers.save_button.title',
  },
  selectVictims: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.victim_title',
  },
  rejectButton: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.reject',
  },
  validateButton: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.validate',
  },
  updateButton: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.update',
  },
  managerDecision: {
    id: 'manager.decision.title',
  },
  judgementAddIncomeCertificateTitle: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.title',
  },
  statusTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.decision.status',
  },
  addIncomeCertificateButtonTitle: {
    id: 'legal_proceeding_page.judgement_add.add_income_certificate.title',
  },
  reasonTitle: {
    id:
      'court_manager_legal_proceedings_page.expert_report.decision.contest_reason',
  },
  intervenantName: {
    id: 'invoice.dialog_info.intervenant.name',
  },
  updateMessage: {
    id: 'judgement_add_update.success',
  },
  typeDocument: {
    id: 'manager_home_page.last_assigned_claims_table_fields.type',
  },
});
